export default{
	totalRevenue:'总收益',
	projectTotalRevenue:'昨日总收益',
	totalProjectRevenue:'项目累计总收益',
	unit:'元',
	moduleRevenue:'功能模块收益',
	peakShaving:'削峰填谷',
	emptyAll:'清空全部',
	saveAll:'保存全部',
	revenueStatistics:'削峰填谷收益统计',
	yesterdayEarnings:'昨日收益:',
	accumulatedIncome:'累计收益',
	tariffType:'电价类型',
	electricityPrice:'电价',
	startMonthAnadendMonth:'开始月份:结束月份',
	startTimeAndendTime:'开始时间:结束时间',
	operation:'操作',
	reservePower:'备电功率',
	standbyHours:'备电小时数',
	saveSuccess:'保存成功',
	deleteSuccess:'删除成功',
	placeholderPrice:'请输入电价',
	monthRage:'0-12月',
	hourRage:'0-24小时',
	flatValue:'平值',
	peakValue:'峰值',
	valleyValue:'谷值',
	tipValue: '尖值',
	selectAlert:'请选择电价类型',
	startMonthAlert:'请输入开始月份',
	endMonthAlert:'请输入结束月份',
	startTimeAlert:'请输入开始时间',
	endTimeAlert:'请输入结束时间',
	noData:'暂无数据'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/incomeAssessment.js